import React, { useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import HeaderBar from "../../react-components/HeaderBar";
import CartPreview from "../../react-components/cart-preview";
import transform from "../../utils/jsonpath-object-transform";

import { toggleMenu, setHeaderHeight, logout } from "../../redux/actions";
import { selectMenuState, selectUserState, selectCookieBannerState, selectMarketBannerState, selectHeaderHeight, selectCartItemsState, selectSessionId, selectShowCartAlert, selectShowCheckoutProgressBar } from "../../selectors/application";

import { addToCartItems, removeCartItems, hideCartAlert, checkoutProgressAction } from "../../redux/actions/actions";
import { getCart } from "../../services/cartService";

import { mappingCartMergeToCartItem } from "../../mappings/ProductDetail";

import "./style.scss";
import { canUseDOM, MathUtils, gtag } from "../../utils";
import { cartInfoSelector } from "../../selectors/gears-checkout";
import LoginPanel from "../../react-components/Login-panel";

const Header = ({ renderining, page, fields, user, lang, showMarketBanner, showCookieBanner, cartInfo, sessionId, match, hideCartAlert, isCartAlertVisible, progressBarIndex }) => {
  const { cartTitleType, cartTitleBody, totalLabel, cartEmptyMessage, ctaToCheckout, loginPanel, productPageLink } = fields;
  const [showCartPreview, setShowCartPreview] = useState();
  const [productsInCart, setProductToCartItemData] = useState([]);
  const [totalPrice, setTotalPrice] = useState(0);
  const [isCartLoading, setCartLoading] = useState(false);
  const [totalCartItems, setTotalCartItems] = useState(0);
  const [showLoginPanel, setShowLoginPanel] = useState(false);
  const dispatch = useDispatch();
  const setLogout = data => dispatch(logout());
  // const fetchCartItemsWithVariation = async () => {
  //   if (cartInfo) {
  //     setCartLoading(true);
  //     const currentShoppingCart = { obj: cartInfo };
  //
  //     let mappingResultToCartItem = transform(
  //       currentShoppingCart,
  //       mappingCartMergeToCartItem({
  //         ...currentShoppingCart,
  //         productPageLink: productPageLink.value.href
  //       })
  //     );
  //
  //     setProductToCartItemData(mappingResultToCartItem.items);
  //     let total = 0,
  //       promotionTotal = 0;
  //     mappingResultToCartItem.items.forEach(item => {
  //       total += item.quantity;
  //       promotionTotal += item.promotionTotal;
  //     });
  //     setTotalCartItems(total);
  //     setTotalPrice(MathUtils.priceFormat(currentShoppingCart.obj.afterDiscountTotalPrice ? currentShoppingCart.obj.afterDiscountTotalPrice - promotionTotal : 0, lang));
  //     setCartLoading(false);
  //   } else {
  //     setTotalPrice(MathUtils.priceFormat(0, lang));
  //   }
  // };
  const _loginPanel = {
    heading: loginPanel?.fields?.heading?.value,
    button: {
      id: "1",
      buttonText: loginPanel?.fields?.button?.fields?.link?.value?.text,
      width: "auto",
      iconName: loginPanel?.fields?.button?.fields?.iconName,
      isDisabled: false,
      callback: value => {
        console.log("accept all button callback", value);
        //logic for logout goes here...
        setLogout();
      }
    },
    link: {
      id: "1",
      text: loginPanel?.fields?.link?.fields?.link?.value?.text,
      width: "auto",
      isDisabled: false,
      linktype: loginPanel?.fields?.link?.fields?.link?.value?.linktype,
      href: loginPanel?.fields?.link?.fields?.link?.value?.href
    }
  };
  const onCartClick = () => {
    if (isCartAlertVisible) {
      hideCartAlert();
    }
    setShowCartPreview(!showCartPreview);
  };

  const click_userName = () => {
    setShowLoginPanel(!showLoginPanel);
  };
  // useEffect(() => {
  //   fetchCartItemsWithVariation().then();
  // }, [cartInfo]);
	
	// 8.14新增埋点
	const sendScrollDepthEvent = (per) => {
		gtag('event', 'L_scroll_depth', {
		  'scroll_percentage': per
		});
	};
	
	const onScroll = () => {
		const scrollY = window.scrollY || document.documentElement.scrollTop;
		const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
		const clientHeight = document.documentElement.clientHeight || window.innerHeight;
		const scrollPercent = (scrollY / (scrollHeight - clientHeight)) * 100;
				
		if (scrollPercent >= 20 && !window.scroll20) {
		  window.scroll20 = true;
		  sendScrollDepthEvent(20);
		}
		if (scrollPercent >= 50 && !window.scroll50) {
		  window.scroll50 = true;
		  sendScrollDepthEvent(50);
		}
		if (scrollPercent >= 90 && !window.scroll90) {
		  window.scroll90 = true;
		  sendScrollDepthEvent(90);
		}
	};

  useEffect(() => {
    // getCart(lang);
		window.addEventListener("scroll", onScroll);
		return () => {
		  window.removeEventListener("scroll", onScroll);
		};
  }, []);

  return (
    <HeaderBar
      {...{ ...fields, user, lang, page }}
      cart={{
        onClick: () => onCartClick(),
        active: showCartPreview,
        numberOfItems: totalCartItems
      }}
      pathname={canUseDOM() ? global.window.location.pathname : ""}
      forceVisible={showMarketBanner || showCookieBanner || showCartPreview || page?.fields?.lockHeaderToTop?.value}
      checkoutProgressIndex={progressBarIndex}
      userNameClick={() => click_userName()}
    >
      <CartPreview
        cartItems={productsInCart}
        total={{
          price: totalPrice,
          label: totalLabel?.value
        }}
        heading={{ html: cartTitleBody, type: cartTitleType }}
        button={ctaToCheckout?.fields}
        message={cartEmptyMessage.value}
        active={showCartPreview}
        onClickOutside={() => setShowCartPreview(false)}
        onItemClick={() => setShowCartPreview(false)}
        isLoading={isCartLoading}
        match={match}
        productPageLink={productPageLink}
      />
      {_loginPanel && <LoginPanel {..._loginPanel} user={user} active={showLoginPanel} onClickOutside={() => setShowLoginPanel(false)} onItemClick={() => setShowLoginPanel(false)} />}
    </HeaderBar>
  );
};

//export default Header;

const mapStateToProps = state => ({
  headerHeight: selectHeaderHeight(state),
  isMenuOpen: selectMenuState(state),
  signedInUser: selectUserState(state),
  showMarketBanner: selectMarketBannerState(state),
  showCookieBanner: selectCookieBannerState(state),
  user: state.user,
  cartInfo: cartInfoSelector(state),
  cartItems: selectCartItemsState(state),
  sessionId: selectSessionId(state),
  isCartAlertVisible: selectShowCartAlert(state),
  progressBarIndex: selectShowCheckoutProgressBar(state)
});
const mapDispatchToProps = dispatch => ({
  setHeaderHeight: val => dispatch(setHeaderHeight(val)),
  toggleMenu: () => dispatch(toggleMenu()),
  addToCartItems: () => dispatch(addToCartItems),
  removeCartItems: () => dispatch(removeCartItems),
  hideCartAlert: () => dispatch(hideCartAlert()),
  checkoutProgress: () => dispatch(checkoutProgressAction),
  dispatch
});
export default connect(mapStateToProps, mapDispatchToProps)(Header);
